export function fetchMetaJsonRequest() {
    // Force browser to check the server.
    const headers = new Headers();
    headers.append('cache-control', 'no-cache');
    // Pragma for backwards compatibility with HTTP/1.0 clients
    headers.append('pragma', 'no-cache');

    const reqInit: RequestInit = { method: 'GET', headers: headers, cache: 'no-cache' };
    const noCacheMeta = new Request('/meta.json', reqInit);
    return fetch(noCacheMeta);
}
